import { render, staticRenderFns } from "./MetricsTab.vue?vue&type=template&id=70f75304&scoped=true&"
import script from "./MetricsTab.vue?vue&type=script&lang=ts&"
export * from "./MetricsTab.vue?vue&type=script&lang=ts&"
import style0 from "./MetricsTab.vue?vue&type=style&index=0&id=70f75304&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f75304",
  null
  
)

export default component.exports